<template lang="pug">
.page-home-brands(v-if="items.length")
  custom-title.mb-5(align="center") Representantes
  v-container
    v-sheet.mx-auto.page-home-brands-list.d-flex.flex-column.flex-sm-row.flex-wrap.justify-space-around.align-center(
      max-width="1080px"
    )
      brand(
        v-for="({ title, img }, i) in items",
        :key="i",
        :title="title",
        :img="files + img"
      )
</template>

<script>
import Brand from "../../cards/Brand.vue";
import CustomTitle from "../../shell/CustomTitle.vue";

const _config = {
  mod: "brands",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
  components: {
    Brand,
    CustomTitle,
  },
};
</script>

<style>
.page-home-brands {
  padding-top: 60px;
  padding-bottom: 60px;
}

.page-home-brands-list.d-flex {
  gap: 32px 64px;
}

@media screen and (max-width: 600px) {
  .page-home-brands {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
</style>